export const dietaryTagIcons = `query DietaryTagIcons {
  dietaryTagIcons {
    tag
    iconUrl
  }
}
`;

export const sendChatMessage = `mutation SendChatMessage($orderId: ID!, $messageInput: ChatMessageInput!) {
  sendChatMessage(messageInput: $messageInput, orderId: $orderId) {
    _id
    message
    user {
      _id
      name
    }
    createdAt
  }
}
`;
export const login = `
mutation Login($email:String,$password:String,$type:String!,$appleId:String,$name:String,$notificationToken:String){
  login(email:$email,password:$password,type:$type,appleId:$appleId,name:$name,notificationToken:$notificationToken){
   userId
   token
   tokenExpiration
   name
   email
   phone
 }
}
`;

// Bringing a deleted account back: a code to its email, then the code.
export const requestAccountReactivation = `
mutation RequestAccountReactivation($email:String!){
  requestAccountReactivation(email:$email)
}
`;

export const reactivateAccount = `
mutation ReactivateAccount($email:String!,$code:String!){
  reactivateAccount(email:$email,code:$code){
   userId
   token
   tokenExpiration
   name
   email
   phone
 }
}
`;

export const emailExist = `
  mutation EmailExist($email:String!){
    emailExist(email:$email){
      _id
    }
  }`;

export const phoneExist = `
mutation PhoneExist($phone:String!){
  phoneExist(phone:$phone){
    _id
  }
}`;

export const sendOtpToEmail = `
  mutation SendOtpToEmail($email: String!, $otp: String!) {
    sendOtpToEmail(email: $email, otp: $otp) {
      result
    }
  }
  `;
export const sendOtpToPhoneNumber = `
mutation SendOtpToPhoneNumber($phone: String!, $otp: String!) {
  sendOtpToPhoneNumber(phone: $phone, otp: $otp) {
    result
  }
}
`;
export const resetPassword = `mutation ResetPassword($password:String!,$email:String!){
  resetPassword(password:$password,email:$email){
    result
  }
}`;

// ── Secure server-side OTP ──────────────────────────────────────────────
export const requestOtp = `mutation RequestOtp($identifier:String!,$channel:String!,$purpose:String){
  requestOtp(identifier:$identifier,channel:$channel,purpose:$purpose){
    result
    message
  }
}`;
export const verifyOtp = `mutation VerifyOtp($identifier:String!,$channel:String!,$purpose:String,$code:String!){
  verifyOtp(identifier:$identifier,channel:$channel,purpose:$purpose,code:$code){
    result
    message
  }
}`;
export const resetPasswordWithOtp = `mutation ResetPasswordWithOtp($email:String!,$code:String!,$newPassword:String!){
  resetPasswordWithOtp(email:$email,code:$code,newPassword:$newPassword){
    result
  }
}`;
export const changePhoneNumber = `mutation ChangePhoneNumber($newPhone:String!){
  changePhoneNumber(newPhone:$newPhone){
    _id name phone email phoneIsVerified emailIsVerified
  }
}`;
export const changeEmail = `mutation ChangeEmail($newEmail:String!){
  changeEmail(newEmail:$newEmail){
    _id name phone email phoneIsVerified emailIsVerified
  }
}`;
export const createUser = `
  mutation CreateUser($phone:String,$email:String,$password:String,$name:String,$notificationToken:String,$appleId:String){
      createUser(
          phone:$phone,
          email:$email,
          password:$password,
          name:$name,
          notificationToken:$notificationToken,
          appleId:$appleId
      ){
          userId
          token
          tokenExpiration
          name
          email
          phone
      }
    }`;

export const updateUser = `
    mutation UpdateUser($name:String!,$phone:String,$phoneIsVerified:Boolean,$emailIsVerified:Boolean){
        updateUser(name:$name,phone:$phone,phoneIsVerified:$phoneIsVerified,emailIsVerified:$emailIsVerified){
          _id
          name
          phone
          phoneIsVerified
          emailIsVerified
        }
      }`;

export const updateNotificationStatus = `
        mutation UpdateNotificationStatus($offerNotification:Boolean!,$orderNotification:Boolean!){
          updateNotificationStatus(offerNotification:$offerNotification,orderNotification:$orderNotification){
            _id
            notificationToken
            isOrderNotification
            isOfferNotification
          }
        }`;

export const profile = `
        query{
          profile{
            _id
            name
            phone
            phoneIsVerified
            email
            emailIsVerified
            notificationToken
            isOrderNotification
            isOfferNotification
            addresses{
              _id
              label
              deliveryAddress
              details
              apartment
              buildingName
              entryCode
              dropoffOption
              instructions
              location{coordinates}
              selected
            }
            favourite
            walletBalance
            hasBlackCard
          }
        }`;

export const order = `query Order($id:String!){
  order(id:$id){
    _id
    orderId
    deliveryAddress{
      latitude
      longitude
      deliveryAddress
      details
      label
    }
    items{
      title
      food
      description
      image
      quantity
      variation{
        title
        price
        discounted
      }
      addons{
        title
        additionalCost
        options{
          title
          price
          quantity
          addons{
            title
            additionalCost
            options{
              title
              price
              quantity
            }
          }
        }
      }
    }
    user{
      _id
      name
      email
    }
    paymentMethod
    paymentLabel
    orderAmount
    orderDate
    expectedTime
    isPickedUp
    orderType
    paymentStatus
    preparationTime
    promotion {
      _id
      code
      discountAmount
    }
  }
}
`;
export const orderPaypal = `query OrderPaypal($id:String!){
  orderPaypal(id:$id){
    _id
    restaurant{ timezone
      _id
      name
      image
      slug
      address
      location {
        coordinates
      }
    }
    deliveryAddress{
      latitude
      longitude
      deliveryAddress
      details
      label
    }
    deliveryCharges
    orderId
    user{
      _id
      phone
      email
      name
    }
    items{
      _id
      food
      variation{
        _id
        title
        price
      }
      addons{
        _id
        additionalCost
        title
        description
        quantityMinimum
        quantityMaximum
        options{
          _id
          title
          price
        }
      }
      quantity
    }
    taxationAmount
    serviceFee
    tipping
    paymentStatus
    paymentMethod
    paymentLabel
    orderAmount
    paidAmount
    blackCardDiscount
    blackCardMember
    promotionDiscount
    orderStatus
    orderDate
    expectedTime
    isPickedUp
    createdAt
    preparationTime
  }
}
`;

export const orderStripe = `query OrderStripe($id:ID!){
  orderStripe(id:$id){
    _id
    restaurant{ timezone
      _id
      name
      image
      slug
      address
      location {
        coordinates
      }
    }
    deliveryAddress{
      latitude
      longitude
      deliveryAddress
      details
      label
    }
    deliveryCharges
    orderId
    user{
      _id
      phone
      email
      name
    }
    items{
      _id
      food
      variation{
        _id
        title
        price
      }
      addons{
        _id
        additionalCost
        title
        description
        quantityMinimum
        quantityMaximum
        options{
          _id
          title
          price
        }
      }
      quantity
    }
    taxationAmount
    serviceFee
    tipping
    paymentStatus
    paymentMethod
    paymentLabel
    orderAmount
    paidAmount
    blackCardDiscount
    blackCardMember
    promotionDiscount
    orderStatus
    orderDate
    expectedTime
    isPickedUp
    createdAt
    preparationTime
  }
}
`;

export const orderStatusChanged = `subscription OrderStatusChanged($userId:ID!){
  orderStatusChanged(userId:$userId){
    order {
      _id
      orderId
      restaurant{ timezone
        _id
        name
        image
        logo
        slug
        address
        phone
        location {
          coordinates
        }
      }
      isSelfDelivery
      deliveryAddress{
        latitude
        longitude
        deliveryAddress
      }
      items{
        _id
        title
        food
        description
        quantity
        variation{
          _id
          title
          price
          discounted
        }
        addons{
          _id
          additionalCost
          options{
            _id
            title
            price
          }
          title
          description
          quantityMinimum
          quantityMaximum
        }
        specialInstructions
      }
      user{
        _id
        name
        phone
      }
      rider{
        _id
        name
        driverType
        phone
        pictureUrl
        location { coordinates }
      }
      firstDeliveryOrderId
      pickupReceiptImage
      deliveryProofImage
      review{
        _id
      }
      paymentMethod
      paymentLabel
      paidAmount
      orderAmount
      orderStatus
      deliveryCharges
      tipping
      taxationAmount
      serviceFee
      orderDate
      expectedTime
      isPickedUp
      orderType
      paymentStatus
      createdAt
      completedAt
      cancelledAt
      preparationTime
      assignedAt
      pickedAt
      deliveredAt
      acceptedAt
      preparedAt
      enRoutePickupAt
      arrivedPickupAt
      enRouteDropoffAt
      arrivedDropoffAt
      fdDriverName
      fdDriverPhone
      fdDriverPhoto
      fdDriverTransport
      fdPickupEta
      fdDropoffEta
      fdDropoffPhoto
      fdTrackerLink
      fdDspTrackerLink
      driverLocation {
        lat
        lng
        name
        phone
      }
      instructions
      walletAmountUsed
      loyaltyCouponDiscount
      blackCardDiscount
      blackCardMember
      supportTicketId
      supportTicketStatus
      refundedItems
      refundedAmount
      promotion {
        _id
        code
        discountAmount
      }
    }
  }
}`;

export const myOrders = `query Orders($offset:Int){
  orders(offset:$offset){
    _id
    orderId
    restaurant{ timezone
      _id
      name
      image
      logo
      slug
      address
      phone
      location {
        coordinates
      }
    }
    isSelfDelivery
    deliveryAddress{
      latitude
      longitude
      deliveryAddress
      label
      details
      apartment
      buildingName
      entryCode
      dropoffOption
    }
    items{
      _id
      title
      food
      description
      quantity
      variation{
        _id
        title
        price
        discounted
      }
      addons{
        _id
        additionalCost
        options{
          _id
          title
          price
          quantity
          addons{
            title
            additionalCost
            options{
              title
              price
              quantity
            }
          }
        }
        title
        description
        quantityMinimum
        quantityMaximum
      }
      specialInstructions
    }
    user{
      _id
      name
      phone
    }
    rider{
      _id
      name
      driverType
      phone
      pictureUrl
      location { coordinates }
    }
    firstDeliveryOrderId
    pickupReceiptImage
    deliveryProofImage
    review{
      _id
      rating
    }
    paymentMethod
    paymentLabel
    paidAmount
    orderAmount
    orderStatus
    deliveryCharges
    tipping
    taxationAmount
    serviceFee
    orderDate
    expectedTime
    isPickedUp
    orderType
    paymentStatus
    createdAt
    completedAt
    cancelledAt
    assignedAt
    deliveredAt
    acceptedAt
    pickedAt
    preparedAt
    enRoutePickupAt
    arrivedPickupAt
    enRouteDropoffAt
    arrivedDropoffAt
    preparationTime
    fdDriverName
    fdDriverPhone
    fdDriverPhoto
    fdDriverTransport
    fdPickupEta
    fdDropoffEta
    fdDropoffPhoto
    fdTrackerLink
    fdDspTrackerLink
    driverLocation {
      lat
      lng
      name
      phone
    }
    instructions
    walletAmountUsed
    loyaltyCouponDiscount
    blackCardDiscount
    blackCardMember
    supportTicketId
    supportTicketStatus
    refundedItems
    refundedAmount
    refundedToCard
    promotion {
      _id
      code
      discountAmount
    }
  }
}
`;

export const placeOrder = `
mutation PlaceOrder($restaurant:ID!,$orderInput:[OrderInput!]!,$paymentMethod:String!,$couponCode:String,$selectedPromoId:ID,$loyaltyCouponCode:String,$tipping:Float!, $serverTip:Float, $driverTip:Float, $taxationAmount: Float!,$address:AddressInput!, $orderDate: String!,$isPickedUp: Boolean!, $deliveryCharges: Float!, $instructions: String, $walletAmountToUse: Float, $qorPaymentToken: String, $qorCvv: String, $qorWallet: String, $qorSavedCardToken: String, $qorSaveCard: Boolean, $isCatering: Boolean, $stopId: ID){
  placeOrder(restaurant:$restaurant,orderInput: $orderInput,paymentMethod:$paymentMethod,couponCode:$couponCode,selectedPromoId:$selectedPromoId,loyaltyCouponCode:$loyaltyCouponCode,tipping:$tipping, serverTip:$serverTip, driverTip:$driverTip, taxationAmount: $taxationAmount, address:$address, orderDate: $orderDate, isPickedUp: $isPickedUp, deliveryCharges: $deliveryCharges, instructions: $instructions, walletAmountToUse: $walletAmountToUse, qorPaymentToken: $qorPaymentToken, qorCvv: $qorCvv, qorWallet: $qorWallet, qorSavedCardToken: $qorSavedCardToken, qorSaveCard: $qorSaveCard, isCatering: $isCatering, stopId: $stopId) {
    _id
    orderId
    restaurant{ timezone
      _id
      name
      image
      slug
      address
      location{coordinates}
    }
    deliveryAddress{
      latitude
      longitude
      deliveryAddress
    }
    items{
      _id
      title
      food
      description
      quantity
      variation{
        _id
        title
        price
        discounted
      }
      addons{
        _id
        additionalCost
        options{
          _id
          title
          price
        }
        title
        description
        quantityMinimum
        quantityMaximum
      }
    }
    user{
      _id
      name
      phone
      email
    }
    rider{
      _id
      name
      driverType
      phone
      pictureUrl
      location { coordinates }
    }
    firstDeliveryOrderId
    pickupReceiptImage
    deliveryProofImage
    review{
      _id
    }
    paymentMethod
    paymentLabel
    paidAmount
    orderAmount
    orderStatus
    orderDate
    expectedTime
    isPickedUp
    deliveryCharges
    tipping
    serverTip
    driverTip
    taxationAmount
    serviceFee
    createdAt
    preparationTime
    loyaltyEarnedMessage
    walletAmountUsed
    loyaltyCouponDiscount
    blackCardDiscount
    blackCardMember
    supportTicketId
    supportTicketStatus
    refundedItems
    refundedAmount
  }
}`;

export const pushToken = `mutation PushToken($token:String){
  pushToken(token:$token){
    _id
    notificationToken
  }
}`;

// Server now generates the OTP — the legacy $otp arg is no longer required.
// We pass an empty string for compatibility with the deployed schema which
// still declares `otp: String!`.
export const forgotPassword = `mutation ForgotPassword($email:String!, $otp:String){
  forgotPassword(email:$email,otp:$otp){
    result
  }
}`;

export const getConfiguration = `query Configuration{
  configuration{
    _id
    currency
    currencySymbol
    deliveryRate
    twilioEnabled
    webClientID
    googleApiKey
    mapboxToken
    webAmplitudeApiKey
    googleMapLibraries
    googleColor
    webSentryUrl
    publishableKey
    clientId
    skipEmailVerification
    skipMobileVerification
    costType
    vapidKey
    nmiTokenizationKey
    serverTipShare
    serviceFee
    qorPaymentsEnabled
    stripePaymentsEnabled
  }
}`;

export const getConfigurationSpecific = `query Configuration{
  configuration{
    webAmplitudeApiKey
  }
}`;

export const getCoupon = `mutation Coupon($coupon:String!,$restaurantId:ID){
  coupon(coupon:$coupon,restaurantId:$restaurantId){
    _id
    title
    discount
    enabled
    kind
    discountValue
    restaurantId
    promotionId
    expiresAt
  }
}`;

export const deleteAddress = `mutation DeleteAddress($id:ID!){
  deleteAddress(id:$id){
    _id
    addresses{
      _id
      label
      deliveryAddress
      details
      apartment
      buildingName
      entryCode
      dropoffOption
      instructions
      location{coordinates}
    }
  }
}`;

export const createAddress = `mutation CreateAddress($addressInput:AddressInput!){
  createAddress(addressInput:$addressInput){
    _id
    addresses{
      _id
      label
      deliveryAddress
      details
      apartment
      buildingName
      entryCode
      dropoffOption
      instructions
      location{coordinates}
      selected
    }
  }
}`;

export const editAddress = `mutation EditAddress($addressInput:AddressInput!){
  editAddress(addressInput:$addressInput){
    _id
    addresses{
      _id
      label
      deliveryAddress
      details
      apartment
      buildingName
      entryCode
      dropoffOption
      instructions
      location{coordinates}
      selected
    }
  }
}`;

export const changePassword = `mutation ChangePassword($oldPassword:String!,$newPassword:String!){
  changePassword(oldPassword:$oldPassword,newPassword:$newPassword){
    _id
  }
}`;

export const restaurantList = `query Restaurants($latitude:Float,$longitude:Float){
  nearByRestaurants(latitude:$latitude,longitude:$longitude){
    offers{
      _id
      name
      tag
      restaurants
    }
    sections{
      _id
      name
      restaurants{
        _id
      }
    }
    restaurants{
      _id
      name
      image
      logo
      slug
      address
      location{coordinates}
      deliveryTime
      defaultPrepTime
      distance
      minimumOrder
      tax
      reviewData{
          total
          ratings
          reviews{
            _id
          }
      }
      categories{
        _id
        title
        icon
        isCatering
        foods{
          _id
          title
        }
      }
      rating
      isAvailable
      timezone
      openingTimes{
        day
        times{
          startTime
          endTime
        }
      }
      enableDelivery
      enablePickup
      enablePickupCOD
      menuLanguage2
      menuLanguage3
      menuLanguageDisplay
      selfDelivery
      cuisines
      activePromotionCount
      hasCatering
      isMobile
      isOpenNow
      openStatusLabel
      deliveryAvailable
      serviceLocation{
        latitude
        longitude
        address
        label
        source
        isOpenNow
        windowLabel
        nextStopLabel
      }
      offers{
        _id
        name
        tag
      }
      categories{
        _id
        title
        icon
      }
      advancedMenus{
        _id
        items{
          _id
          name
          alternateName1
          alternateName2
          description
          categoryName
          categoryIcon
        }
      }
      timezone
      openingTimes{
      day
      times{
        startTime
        endTime
      }
    }
  }
}
}`;

// The Catering page: restaurants with catering inside the radius a super admin
// sets. distance is km, like nearByRestaurants. catering{} and
// cateringDealCount resolve per restaurant, which is fine on this short list
// and why they stay off the big list above.
export const CATERING_RESTAURANTS = `query CateringRestaurants($latitude:Float!,$longitude:Float!){
  cateringRestaurants(latitude:$latitude,longitude:$longitude){
    radiusMiles
    restaurants{
      _id
      name
      image
      logo
      slug
      address
      deliveryTime
      defaultPrepTime
      distance
      reviewData{
        total
        ratings
        reviews{
          _id
        }
      }
      rating
      isAvailable
      timezone
      openingTimes{
        day
        times{
          startTime
          endTime
        }
      }
      cuisines
      activePromotionCount
      isMobile
      isOpenNow
      openStatusLabel
      serviceLocation{
        latitude
        longitude
        address
        label
        source
        isOpenNow
        windowLabel
        nextStopLabel
      }
      offers{
        _id
        name
        tag
      }
      categories{
        _id
        title
        icon
        isCatering
      }
      hasCatering
      cateringDeliveryAvailable
      cateringDealCount
      catering{
        restaurantId
        leadTimeMinutes
        deliveryMode
        allowPickup
        minimumOrder
        maxGuests
      }
      cateringDietaryTags
      cateringItemNames
      cateringServes
      cateringFromPrice
    }
  }
}`;

export const restaurant = `query Restaurant($id:String,$slug:String,$stopId:ID){
  restaurant(id:$id,slug:$slug,stopId:$stopId){
    _id
    orderId
    orderPrefix
    name
    image
    logo
    cuisines
    slug
    address
    location{coordinates}
    isMobile
    mobileDeliveryEnabled
    isOpenNow
    openStatusLabel
    orderingStop{
      truckId
      truckName
      date
      canOrder
      note
      startsAt
      endsAt
      stop{
        _id
        label
        address
        imageUrl
        windowLabel
        scheduleLabel
        hasOwnMenu
        rating
        ratingCount
      }
    }
    serviceLocation{
      latitude
      longitude
      address
      label
      source
      isOpenNow
      windowLabel
      nextStopLabel
    }
    currentStop{
      _id
      label
      address
      windowLabel
      stopDate
      dayOfWeek
    }
    nextStop{
      _id
      label
      address
      windowLabel
      stopDate
      dayOfWeek
      recurrence
    }
    upcomingStops{
      _id
      label
      address
      windowLabel
      stopDate
      dayOfWeek
      startMinute
      endMinute
    }
    deliveryTime
    preparationTime
    minimumOrder
    tax
    serviceFee
    hasCatering
    cateringDealCount
    catering{
      restaurantId
      leadTimeMinutes
      prepTimeMinutes
      deliveryMode
      allowPickup
      minimumOrder
      serviceFee
    }
    reviewData{
      total
      ratings
      reviews{
        _id
        user{
          _id
          name
        }
        rating
        description
        createdAt
      }
    }
    activeClosure{
      _id
      name
      dateLabel
      note
    }
    upcomingClosures{
      _id
      name
      dateLabel
    }
    categories{
      _id
      title
      description
      alternateTitle1
      alternateTitle2
      icon
      displayOrder
      isCatering
      foods{
        _id
        title
        image
        description
        variations{
          _id
          title
          price
          discounted
          addons
        }
      }
    }
    options{
      _id
      title
      description
      price
    }
    addons{
      _id
      options
      title
      description
      quantityMinimum
      quantityMaximum
    }
    advancedMenus{
      _id
      name
      description
      menuType
      isActive
      displayOrder
      markupPercent
      roundingMode
      roundingValue
      startTime
      endTime
      daySchedule
      activeClosure{
        _id
        name
        dateLabel
      }
      items{
        _id
        name
        alternateName1
        alternateName2
        description
        imageUrl
        isAiImage
        isAiDescription
        categoryName
        subcategoryName
        cateringItemId
        serves
        variantServes
        pricingMode
        basePrice
        variantPrices
        dietaryTags
        allergenTags
        isActive
        isAvailable
        stockLeft
        is86ed
        displayOrder
        isFeatured
        likedPercent
        voteCount
        mostLikedRank
        modifierGroups{
          _id
          name
          description
          selectionType
          minSelections
          maxSelections
          isRequired
          groupRequirement
          additionalCost
          allowDuplicates
          maxDuplicates
          duplicatePricingMode
          duplicatePrices
          displayOrder
          modifiers{
            _id
            memberType
            modifier{
              _id
              name
              libraryStatus {
                is86ed
              }
            }
            item{
              _id
              name
              description
              imageUrl
              pricingMode
              basePrice
              variantPrices
              isAvailable
              is86ed
              modifierGroups{
                _id
                name
                description
                selectionType
                minSelections
                maxSelections
                isRequired
                groupRequirement
                additionalCost
                allowDuplicates
                maxDuplicates
                duplicatePricingMode
                duplicatePrices
                displayOrder
                modifiers{
                  _id
                  memberType
                  modifier{
                    _id
                    name
                    libraryStatus {
                      is86ed
                    }
                  }
                  priceOverrideMode
                  fixedPrice
                  variantPrices
                  displayOrder
                  isDefault
                  isHidden
                }
              }
            }
            priceOverrideMode
            fixedPrice
            variantPrices
            displayOrder
            isDefault
            isHidden
            nestedGroups
          }
        }
        optionGroups{
          _id
          name
          choices
          selectionType
          isRequired
        }
      }
    }
    zone{
      _id
      title
      tax
    }
    rating
    isAvailable
    enableDelivery
    enablePickup
    enablePickupCOD
    menuLanguage2
    menuLanguage3
    menuLanguageDisplay
    selfDelivery
    timezone
    openingTimes{
      day
      times{
        startTime
        endTime
      }
    }
  }
}`;

export const selectAddress = `mutation SelectAddress($id:String!){
  selectAddress(id:$id){
    _id
    addresses{
      _id
      label
      deliveryAddress
      details
      apartment
      buildingName
      entryCode
      dropoffOption
      instructions
      location{coordinates}
      selected
    }
  }
}`;

export const subscriptionRiderLocation = `subscription SubscriptionRiderLocation($riderId:ID!){
  subscriptionRiderLocation(riderId:$riderId) {
    _id
    location {coordinates}
  }
}`;

export const rider = `query Rider($id:ID!){
  rider(id:$id){
    _id
    name
    location {coordinates}
  }
}`;

export const reviewOrder = `mutation ReviewOrder(
  $order:ID!,
  $rating:Int!,
  $description:String,
){
  reviewOrder(reviewInput:{
    order:$order,
    rating:$rating,
    description:$description,
  }){
    _id
    orderId
    restaurant{ timezone
      _id
      name
      image
      slug
      address
    }
    deliveryAddress{
      latitude
      longitude
      deliveryAddress
    }
    items{
      _id
      title
      food
      description
      quantity
      variation{
        _id
        title
        price
        discounted
      }
      addons{
        _id
        additionalCost
        options{
          _id
          title
          price
        }
        title
        description
        quantityMinimum
        quantityMaximum
      }
    }
    user{
      _id
      name
      phone
    }
    rider{
      _id
      name
      driverType
      phone
      pictureUrl
      location { coordinates }
    }
    firstDeliveryOrderId
    pickupReceiptImage
    deliveryProofImage
    review{
      _id
    }
    paymentMethod
    paymentLabel
    paidAmount
    orderAmount
    orderStatus
    orderDate
    expectedTime
    isPickedUp
    tipping
    taxationAmount
    serviceFee
    createdAt
    completedAt
    preparationTime
  }
}`;

// Per-dish thumbs up/down (DoorDash-style "% liked" / "Most liked").
export const submitDishVotes = `mutation SubmitDishVotes($orderId:ID!, $votes:[DishVoteInput!]!){
  submitDishVotes(orderId:$orderId, votes:$votes){
    foodId
    itemType
    vote
  }
}`;

export const myDishVotesForOrder = `query MyDishVotesForOrder($orderId:ID!){
  myDishVotesForOrder(orderId:$orderId){
    foodId
    itemType
    vote
  }
}`;

export const subscriptionOrder = `subscription SubscriptionOrder($id:ID!){
  subscriptionOrder(id:$id){
      _id
      orderStatus
      rider{
          _id
      }
      completedAt
  }
}`;

export const getTaxation = `query Taxes{
  taxes {
    _id
    taxationCharges
    enabled
    }
  }`;

export const getTipping = `query Tips{
    tips {
      _id
      tipVariations
      enabled
    }
  }`;

export const FavouriteRestaurant = `query UserFavourite ($latitude:Float,$longitude:Float){
    userFavourite(latitude:$latitude,longitude:$longitude) {
      _id
      orderId
      orderPrefix
      name
      image
      logo
      slug
      address
      location{coordinates}
      deliveryTime
      defaultPrepTime
      distance
      minimumOrder
      tax
      reviewData{
        total
        ratings
        reviews{
          _id
          order{
            user{
              _id
              name
              email
            }
          }
          rating
          description
          createdAt
        }
      }
      categories{
        _id
        title
        icon
        foods{
          _id
          title
          image
          description
          variations{
            _id
            title
            price
            discounted
            addons
          }
        }
      }
      options{
        _id
        title
        description
        price
      }
      addons{
        _id
        options
        title
        description
        quantityMinimum
        quantityMaximum
      }
      rating
      isAvailable
      openingTimes{
        day
        times{
          startTime
          endTime
        }
      }
     }
  }`;

export const addFavouriteRestaurant = `mutation AddFavourite($id:ID!){
    addFavourite(id:$id){
      _id
      addresses{
        _id
        label
        deliveryAddress
        details
        apartment
        buildingName
        entryCode
        dropoffOption
        instructions
        location{coordinates}
        selected
      }
    }
  }`;

export const saveNotificationTokenWeb = `mutation SaveNotificationTokenWeb($token:String!){
  saveNotificationTokenWeb(token:$token){
    _id
    notificationToken
  }
}`;

export const savePushSubscription = `mutation SavePushSubscription($endpoint:String!,$p256dh:String!,$auth:String!){
  savePushSubscription(endpoint:$endpoint,p256dh:$p256dh,auth:$auth){
    _id
  }
}`;

export const deletePushSubscription = `mutation DeletePushSubscription($endpoint:String!){
  deletePushSubscription(endpoint:$endpoint){
    _id
  }
}`;

export const sendTestPushNotification = `mutation SendTestPushNotification{
  sendTestPushNotification
}`;

export const chat = `query Chat($order: ID!) {
  chat(order: $order) {
    _id
    message
    user {
      _id
      name
    }
    createdAt
  }
}`;

export const subscriptionNewMessage = `subscription SubscriptionNewMessage($order:ID!){
  subscriptionNewMessage(order:$order){
    _id
    message
    user {
      _id
      name
    }
    createdAt
  }
}`;

export const abortOrder = `mutation AbortOrder($id: ID!) {
  abortOrder(id: $id) {
    _id
    orderId
    orderStatus
    paymentStatus
  }
}`;

export const customerConfirmPickup = `mutation CustomerConfirmPickup($id: ID!) {
  customerConfirmPickup(id: $id) {
    _id
    orderId
    orderStatus
    deliveredAt
    completedAt
  }
}`;

export const getCuisines = `query GetCuisines {
  getCuisines {
    _id
    name
    image
  }
}`;

export const evaluateCart = `
  query EvaluateCart($input: CartEvaluationInput!) {
    evaluateCart(input: $input) {
      appliedPromotion {
        _id
        name
        couponCode
      }
      discountAmount
      discountedDeliveryFee
      originalSubtotal
      discountedSubtotal
      finalTotal
      explanationMessage
      rejectionMessage
      freeItems {
        foodId
        title
      }
    }
  }
`;

export const activePromotionsForCustomer = `
  query ActivePromotionsForCustomer($restaurantId: ID, $latitude: Float, $longitude: Float, $pickup: Boolean, $stopId: ID) {
    activePromotionsForCustomer(restaurantId: $restaurantId, latitude: $latitude, longitude: $longitude, pickup: $pickup, stopId: $stopId) {
      _id
      restaurantId
      restaurantName
      restaurantSlug
      restaurantLogo
      restaurantImage
      name
      description
      promotionType
      triggerType
      couponCode
      channel
      isCatering
      startAtUtc
      endAtUtc
      conditions {
        conditionType
        params
      }
      rewards {
        rewardType
        params
      }
    }
  }
`;

export const GET_DELIVERY_FEE = `
  query GetDeliveryFee($restaurantId: ID!, $latitude: Float!, $longitude: Float!, $at: String, $catering: Boolean, $stopId: ID) {
    getDeliveryFee(restaurantId: $restaurantId, latitude: $latitude, longitude: $longitude, at: $at, catering: $catering, stopId: $stopId) {
      fee
      zoneName
      available
      isSelfDelivery
      noZonesConfigured
      blackCardDiscount
    }
  }
`;


export const myLoyaltyVouchers = `
  query MyLoyaltyVouchers {
    myLoyaltyVouchers {
      voucherCode
      voucherExpiresAt
      restaurantId
      restaurantName
      promoName
      voucherAmount
    }
  }
`;

export const myAllLoyaltyVouchers = `
  query MyAllLoyaltyVouchers {
    myAllLoyaltyVouchers {
      voucherCode
      voucherExpiresAt
      restaurantId
      restaurantName
      promoName
      voucherAmount
      status
      usedAt
    }
  }
`;

export const myLoyaltyPoints = `
  query MyLoyaltyPoints {
    myLoyaltyPoints {
      balance
      lifetimePoints
      tier
      nextTier
      pointsToNextTier
      transactions {
        _id
        type
        points
        status
        description
        createdAt
      }
    }
  }
`;

// Just the balance, for the header's "10,433 pts" — the full myLoyaltyPoints
// query also pulls every transaction.
export const myLoyaltyBalance = `
  query MyLoyaltyBalance {
    myLoyaltyPoints {
      balance
    }
  }
`;

export const loyaltyRedemptionTiers = `
  query LoyaltyRedemptionTiers {
    loyaltyRedemptionTiers {
      _id
      pointsRequired
      couponValue
      isActive
      sortOrder
    }
  }
`;

export const myLoyaltyCoupons = `
  query MyLoyaltyCoupons {
    myLoyaltyCoupons {
      _id
      code
      discountValue
      pointsSpent
      status
      redeemedAt
      expiresAt
      usedAt
    }
  }
`;

export const redeemLoyaltyPoints = `
  mutation RedeemLoyaltyPoints($tierId: ID!) {
    redeemLoyaltyPoints(tierId: $tierId) {
      _id
      code
      discountValue
      pointsSpent
      status
      expiresAt
    }
  }
`;

export const loyaltyTierConfig = `
  query LoyaltyTierConfig {
    loyaltyTierConfig {
      _id
      tierName
      tierKey
      minLifetimePoints
      maxLifetimePoints
      earningMultiplier
      sortOrder
    }
  }
`;

// ─── Support / Wallet ─────────────────────────────────────────────────────────

export const submitSupportTicket = `
  mutation SubmitSupportTicket(
    $orderId: Int!
    $issueType: IssueType!
    $description: String
    $evidenceUrls: [String]
    $affectedItems: [AffectedItemInput]
    $requestedAmount: Float
  ) {
    submitSupportTicket(
      orderId: $orderId
      issueType: $issueType
      description: $description
      evidenceUrls: $evidenceUrls
      affectedItems: $affectedItems
      requestedAmount: $requestedAmount
    ) {
      id ticketNumber issueType assignedQueue status createdAt
      refundRequest { id requestedAmount status }
    }
  }
`;

export const addTicketFollowUp = `
  mutation AddTicketFollowUp(
    $ticketId: ID!
    $issueType: IssueType
    $description: String
    $evidenceUrls: [String]
    $affectedItems: [AffectedItemInput]
  ) {
    addTicketFollowUp(
      ticketId: $ticketId
      issueType: $issueType
      description: $description
      evidenceUrls: $evidenceUrls
      affectedItems: $affectedItems
    ) {
      id ticketId senderType message evidenceUrls issueType createdAt
    }
  }
`;

export const myTickets = `
  query MyTickets {
    myTickets {
      id ticketNumber orderId orderDisplayId restaurantId issueType
      assignedQueue status resolutionType resolutionNote resolvedAt createdAt
      refundRequest { id requestedAmount approvedAmount status customerChoice creditTotal creditScope cardRefundAmount }
    }
  }
`;

export const myTicket = `
  query MyTicket($ticketId: ID!) {
    myTicket(ticketId: $ticketId) {
      id ticketNumber orderId orderDisplayId restaurantId issueType
      assignedQueue description evidenceUrls
      status resolutionType resolutionNote resolvedAt createdAt updatedAt
      refundRequest {
        id requestedAmount approvedAmount status adminDecision adminDecisionNote restaurantDecision restaurantDecisionNote affectedItems
        customerChoice creditScope creditRestaurantName bonusAmount creditTotal
        walletRefundAmount cardRefundAmount cardLabel cardRefundDays cardRefundStatus
      }
      messages { id senderType senderName message evidenceUrls issueType isRead createdAt }
    }
  }
`;

// The customer picks how an approved refund comes back: ORIGINAL | CREDIT.
export const chooseRefundOption = `
  mutation ChooseRefundOption($ticketId: ID!, $choice: String!) {
    chooseRefundOption(ticketId: $ticketId, choice: $choice) {
      id status
      refundRequest { id status customerChoice cardRefundStatus }
    }
  }
`;

// Credit only usable at one restaurant (support refunds that were its fault).
export const myStoreCredits = `
  query MyStoreCredits {
    myStoreCredits { restaurantId restaurantName restaurantImage restaurantSlug balance }
  }
`;

// What can be spent at one restaurant's checkout: platform + its store credit.
export const myCheckoutCredit = `
  query MyCheckoutCredit($restaurantId: ID!) {
    myCheckoutCredit(restaurantId: $restaurantId) { platform store total }
  }
`;

export const myWalletBalance = `
  query MyWalletBalance {
    myWalletBalance
  }
`;

export const myWalletTransactions = `
  query MyWalletTransactions($page: Int, $limit: Int) {
    myWalletTransactions(page: $page, limit: $limit) {
      id type source amount balanceAfter orderId restaurantId restaurantName note expiresAt createdAt
    }
  }
`;

export const myBlackCardSubscription = `
  query MyBlackCardSubscription {
    myBlackCardSubscription {
      _id
      status
      processor
      monthlyPrice
      currentPeriodStart
      currentPeriodEnd
      cancelledAt
      createdAt
    }
  }
`;

export const blackCardProgram = `
  query BlackCardProgram {
    blackCardProgram {
      enabled
      monthlyPrice
      deliveryDiscountCap
      bonusPointsPerOrder
    }
  }
`;

export const myQorSavedCards = `
  query MyQorSavedCards {
    myQorSavedCards {
      token
      last4
      brand
      cardholderName
      nickname
      expiry
    }
  }
`;

export const deleteQorSavedCard = `
  mutation DeleteQorSavedCard($token: String!, $last4: String!) {
    deleteQorSavedCard(token: $token, last4: $last4) {
      ok
      code
      message
    }
  }
`;

export const subscribeBlackCard = `
  mutation SubscribeBlackCard($paymentMethodId: String, $processor: String, $qorPaymentToken: String) {
    subscribeBlackCard(paymentMethodId: $paymentMethodId, processor: $processor, qorPaymentToken: $qorPaymentToken) {
      _id
      status
      currentPeriodEnd
    }
  }
`;

export const updateBlackCardPaymentMethod = `
  mutation UpdateBlackCardPaymentMethod($qorPaymentToken: String, $paymentMethodId: String) {
    updateBlackCardPaymentMethod(qorPaymentToken: $qorPaymentToken, paymentMethodId: $paymentMethodId) {
      _id
      status
      currentPeriodEnd
      nextBillingDate
    }
  }
`;

export const cancelBlackCard = `
  mutation CancelBlackCard {
    cancelBlackCard {
      _id
      status
      currentPeriodEnd
      cancelledAt
    }
  }
`;

export const submitPartnerSignup = `mutation SubmitPartnerSignup($input: PartnerSignupInput!) {
  submitPartnerSignup(input: $input) {
    _id
    restaurantName
    createdAt
  }
}`;

export const mostOrderedItems = `query MostOrderedItems($restaurantId: ID!, $limit: Int) {
  mostOrderedItems(restaurantId: $restaurantId, limit: $limit) {
    _id
    title
    image
    description
    price
    orderCount
    likedPercent
    voteCount
    mostLikedRank
  }
}`;

// ── Server-side carts ──────────────────────────────────────────────────────
// Carts follow the customer between devices (backend migration 082). `items`
// and `meta` cross the wire as JSON strings — see the backend schema for why.
export const myCarts = `query MyCarts {
  myCarts {
    restaurantId
    items
    meta
    clientUpdatedAt
  }
}`;

export const saveCart = `mutation SaveCart($cart: SavedCartInput!) {
  saveCart(cart: $cart) {
    restaurantId
    items
    meta
    clientUpdatedAt
  }
}`;

export const deleteCart = `mutation DeleteCart($restaurantId: ID!) {
  deleteCart(restaurantId: $restaurantId) {
    restaurantId
    items
    meta
    clientUpdatedAt
  }
}`;

export const mergeCarts = `mutation MergeCarts($carts: [SavedCartInput!]!) {
  mergeCarts(carts: $carts) {
    restaurantId
    items
    meta
    clientUpdatedAt
  }
}`;

// Minimal restaurant lookup used to name a saved cart whose meta is missing
// (parked before meta capture existed, or from a path that had none). The full
// `restaurant` query drags the entire menu with it.
export const restaurantBrief = `query RestaurantBrief($id:String){
  restaurant(id:$id){
    _id
    name
    slug
    image
    isActive
  }
}`;


// ── Table reservations ──────────────────────────────────────────────────────
// The restaurant's own bookable times; guests must be signed in to book.
export const restaurantForReservation = `query RestaurantForReservation($slug:String){
  restaurant(slug:$slug){
    _id
    name
    slug
    image
    address
  }
}`;

export const publicReservationSettings = `query PublicReservationSettings($restaurantId:ID!){
  publicReservationSettings(restaurantId:$restaurantId){
    enabled
    maxPartySize
    daysAhead
    leadTimeMin
    slotIntervalMin
    timezone
    today
    restaurantName
  }
}`;

export const reservationSlots = `query ReservationSlots($restaurantId:ID!,$date:String!,$partySize:Int!){
  reservationSlots(restaurantId:$restaurantId,date:$date,partySize:$partySize){
    time
    startsAt
    available
  }
}`;

export const createWebReservation = `mutation CreateWebReservation($restaurantId:ID!,$partySize:Int!,$startsAt:String!,$guestName:String,$guestPhone:String,$guestEmail:String,$notes:String,$clientOpId:String){
  createWebReservation(restaurantId:$restaurantId,partySize:$partySize,startsAt:$startsAt,guestName:$guestName,guestPhone:$guestPhone,guestEmail:$guestEmail,notes:$notes,clientOpId:$clientOpId){
    _id
    status
    guestName
    partySize
    reservedFor
    endsAt
    confirmationCode
  }
}`;

export const myReservations = `query MyReservations{
  myReservations{
    _id
    status
    source
    guestName
    partySize
    reservedFor
    endsAt
    durationMin
    notes
    confirmationCode
    createdAt
    restaurant{
      _id
      name
      slug
      address
      phone
      image
    }
  }
}`;

export const cancelMyReservation = `mutation CancelMyReservation($id:ID!){
  cancelMyReservation(id:$id){
    _id
    status
  }
}`;

// Food trucks (backend migration 145): the trucks under one restaurant, and
// one truck's stops a month at a time.
const truckStopFields = `
  _id
  truckId
  label
  address
  latitude
  longitude
  imageUrl
  windowLabel
  scheduleLabel
  hasOwnMenu
  rating
  ratingCount
`;

const foodTruckFields = `
  _id
  name
  isOpenNow
  statusLabel
  imageUrl
  nextStopDate
  currentStop{ ${truckStopFields} }
  nextStop{ ${truckStopFields} }
`;

export const foodTrucks = `query FoodTrucks($slug:String,$restaurantId:ID){
  foodTrucks(slug:$slug,restaurantId:$restaurantId){ ${foodTruckFields} }
}`;

export const truckSchedule = `query TruckSchedule($truckId:ID!,$month:String){
  truckSchedule(truckId:$truckId,month:$month){
    restaurantId
    month
    monthLabel
    prevMonth
    nextMonth
    truck{ ${foodTruckFields} }
    days{
      date
      dateLabel
      isToday
      isPast
      isOpenNow
      canOrder
      orderNote
      stop{ ${truckStopFields} }
      deals{ _id name description couponCode promotionType }
    }
  }
}`;

// Restaurant list "Order again": the last few orders, only what the cards and
// Reorder need (the full myOrders query is ~1MB; this is a handful of rows).
export const orderAgainOrders = `query OrderAgain($limit:Int){
  orders(offset:0, limit:$limit){
    _id
    createdAt
    orderStatus
    isPickedUp
    orderAmount
    deliveryCharges
    tipping
    taxationAmount
    serviceFee
    restaurant{ timezone
      _id
      name
      slug
      image
      logo
    }
    items{
      _id
      title
      food
      image
      quantity
      variation{
        _id
      }
      addons{
        _id
        options{
          _id
        }
      }
    }
  }
}`;

// Restaurant list "Most ordered near you": across the restaurants on screen.
export const mostOrderedNearby = `query MostOrderedNearby($restaurantIds:[ID!]!, $limit:Int){
  mostOrderedNearby(restaurantIds:$restaurantIds, limit:$limit){
    _id
    title
    image
    isAiImage
    price
    priceIsFrom
    restaurantId
    restaurantName
    restaurantSlug
  }
}`;

// Catering page "Suggest a restaurant" (signed-in customers; backend migration 139).
export const suggestRestaurant = `mutation SuggestRestaurant($restaurantName:String!, $note:String, $city:String, $address:String, $latitude:Float, $longitude:Float){
  suggestRestaurant(restaurantName:$restaurantName, note:$note, city:$city, address:$address, latitude:$latitude, longitude:$longitude)
}`;

// Nobody delivers to the chosen address (components/PickupNearby, backend
// migration 139): restaurants with pickup within the admin's pickup radius, no
// delivery-zone filter. distance is in km, like nearByRestaurants.
export const pickupRestaurantsNear = `query PickupRestaurantsNear($latitude:Float!, $longitude:Float!){
  pickupRestaurantsNear(latitude:$latitude, longitude:$longitude){
    radiusMiles
    restaurants{
      _id
      name
      image
      logo
      address
      city
      slug
      cuisines
      reviewData{
        total
        ratings
      }
      isActive
      isAvailable
      isMobile
      isOpenNow
      openStatusLabel
      timezone
      openingTimes{
        day
        times{
          startTime
          endTime
        }
      }
      defaultPrepTime
      preparationTime
      distance
      enablePickup
      location{
        coordinates
      }
    }
  }
}`;

// One answer per saved address, in order: does any restaurant deliver there?
export const deliveryAvailableAt = `query DeliveryAvailableAt($points:[GeoPointInput!]!){
  deliveryAvailableAt(points:$points)
}`;

export const onDeliveryWaitlist = `query OnDeliveryWaitlist($latitude:Float!, $longitude:Float!){
  onDeliveryWaitlist(latitude:$latitude, longitude:$longitude)
}`;

export const joinDeliveryWaitlist = `mutation JoinDeliveryWaitlist($latitude:Float!, $longitude:Float!, $address:String, $city:String){
  joinDeliveryWaitlist(latitude:$latitude, longitude:$longitude, address:$address, city:$city)
}`;

// My Orders a page at a time (backend graphql/resolvers/orderList.js): the
// same order fields as myOrders, with the page's filters.
export const myOrdersPage = myOrders.replace(
  "query Orders($offset:Int){\n  orders(offset:$offset){",
  "query OrdersPage($offset:Int,$limit:Int,$status:String,$search:String,$restaurantSlug:String){\n  orders(offset:$offset,limit:$limit,status:$status,search:$search,restaurantSlug:$restaurantSlug){"
);

export const myOrdersCounts = `query OrdersCounts($status:String,$search:String,$restaurantSlug:String){
  total: ordersCount(restaurantSlug:$restaurantSlug)
  matching: ordersCount(status:$status,search:$search,restaurantSlug:$restaurantSlug)
}`;
